'use client';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

import NotFound from '@/public/icons/404.svg';

const MoNotFound = () => {
  const t = useTranslations('404');

  const router = useRouter();
  return (
    <section className="w-full h-screen flex flex-col justify-center items-center">
      <figure className="w-full h-[96px] mb-[8px]">
        <NotFound width="100%" height="100%" viewBox="0 0 201 68" />
      </figure>
      <p className="text-[24px] font-semibold leading-[31px] text-center mb-[4px]">{t('title')}</p>
      <p className="text[18px] leading-[28px] font-normal text-center text-[#434343]">
        {t('description')}
      </p>
      <article className="fixed left-0 bottom-0 w-screen px-[20px] pb-[42px]">
        <button
          className="bg-[#004EFF] w-full py-[16px] px-[24px] rounded-[40px] text-white text-[18px] leading-[28px] text-center"
          onClick={router.back}
        >
          {t('button')}
        </button>
      </article>
    </section>
  );
};

export default MoNotFound;
